import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/services/api.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

  error = '';

  success = '';

  eMail = '';

  constructor(private api : ApiService) { }

  ngOnInit() {
  }  

  submit() {

    this.error = "";
    this.success = "";

    var arg =  {
      EMail : this.eMail
    };

    this.api.post('account/resetpassword', arg).subscribe((d : any) => {
      this.success = d;
      
    },
    e => {
      this.error = "Das Passwort konnte nicht zurückgesetzt werden";
    })

  }

}
